/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React from 'react';
import ReactDOM from 'react-dom';
import SlotEditorDOMAPI from './SlotEditorDOMAPI';
import SlotEditor from '../SlotEditor';
const APIFactory = require('gemini/lib/@waca/dashboard-common/dist/core/APIFactory');

class SlotEditorDOM {

	constructor({ features }) {
		this._dashboardApi = features.API;
		this._slideout = features.InAppSlideoutDOM;
		this._slotEditorState = features.SlotEditorState;
		this._api = null;
		this._parent = null;
		this._extensions = [];

		this._api = APIFactory.createAPI(this, [SlotEditorDOMAPI]);
		this._slideout.registerView(this.getProviderId(), this);
	}

	getAPI() {
		return this._api;
	}

	addExtension(extension) {
		this._extensions.push(extension);
	}

	getProviderId() {
		return this._slotEditorState.getProviderId();
	}

	render(options) {
		const {
			parentNode = null
		} = options || {};

		if (parentNode && document.body.contains(parentNode)) {
			if(this._parent !== parentNode) {
				//before a new render, clear previous rendered SlotEditor
				this.unmount();
				this._parent = parentNode;
				return new Promise((resolve) => {
					ReactDOM.render(
						<SlotEditor
							dndManager={this._dashboardApi.getDashboardSvc('.DndManager')}
							slotEditorModel={this._slotEditorState.getModel()}
							logger={this._dashboardApi.getService(this._dashboardApi.GLOBAL_SERVICES.LOGGER)}
							extensions={this._extensions}
						/>,
						parentNode,
						() => resolve()
					);
				});
			}
		}

		return Promise.resolve(null);
	}

	unmount() {
		if (this._parent) {
			ReactDOM.unmountComponentAtNode(this._parent);
			this._parent = null;
		}
	}

	destroy() {
		this.unmount();
		this._api = null;
		this._dashboardApi = null;
		this._slotEditorState = null;
		this._slideout = null;
	}
}

module.exports = SlotEditorDOM;



// WEBPACK FOOTER //
// ./src/js/dashboard/SlotEditorDOM.js